import React from 'react';
import FormWrapper from './FormWrapper';

const FormTextarea = function (props) {
  const { name, required } = props;
  const { text, ...rest } = props;

  return (
    <FormWrapper required={required} name={name} text={text} type="textarea">
      <textarea id={name} name={name} cols="70" rows="50" {...rest} onChange={() => { /* let event bubble */ }} />
    </FormWrapper>
  );
};

export default FormTextarea;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormTextarea.js